module.exports = __webpack_public_path__ + "dad41d7efb094d382a39dd1d08686c78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index/home-bg.jpg
// module id = 1127
// module chunks = 73